import { getScopeGroupId, oauth2Instance } from "./liferay";

export async function fetchBlogs(category = "All") {
  try {
    const groupId = getScopeGroupId();
    const headers = await oauth2Instance.getHeaders();

    const response = await fetch(
      `${oauth2Instance.getPortalURL()}/o/sclservices/blogs/get-user-blogs/${groupId}`,
      {
        method: "POST",
        headers,
        body: JSON.stringify({ category }),
      }
    );

    if (!response.ok) {
      throw new Error("Failed to fetch blogs");
    }

    const data = await response.json();
    return data;

  } catch (error) {
    console.error("Blog fetch error:", error);
    return [];
  }
}